<template>
  <div>
    <transition name="background-popup">
      <div @click.stop="$store.commit('closed')" v-if="$store.getters.background" class="view-back"></div>
    </transition>
    <transition name="ticket-up">
      <ticket v-if="$store.getters.ticket"></ticket>
    </transition>
    <transition name="avatar-up">
      <ReadQR v-if="$store.getters.ReadQR"></ReadQR>
      <sendMessage v-if="$store.getters.sendMessage"></sendMessage>
    </transition>
  </div>
</template>

<script>
import Ticket from "./Ticket";
import ReadQR from "./ReadQR";
import sendMessage from "./sendMessage";

export default {
  components: {
    Ticket,
    ReadQR,
    sendMessage
  },
  computed: {
    background() {
      return this.$store.getters.background;
    }
  },
  watch: {
    background(newCount, oldCount) {
      newCount
        ? document.body.classList.add("block-view")
        : document.body.classList.remove("block-view");
    }
  }
};
</script>

<style scoped>
.opacity {
  opacity: var(--background);
}
.view-back {
  height: 100vh;
  width: 100vw;
  z-index: 500;
  opacity: var(--background);
  background: #000001;
  position: fixed;
  top: 0;
}
</style>